module.exports = __webpack_public_path__ + "static/media/golf-carousel-2-800x1280.23273e8e.jpg";